module.exports = __webpack_public_path__ + "img/codeimg.65e830d2.jpg";